<template>
  <div class="page-header-index-wide">
    <a-card :bordered="false">
      <a slot="extra">
        <a-icon
          v-if="!closeVisible"
          :style="{color:'black'}"
          slot="extra"
          type="close"
          @click="onClose"
        />
        <a-icon
          v-if="closeVisible"
          :style="{color:'black'}"
          slot="extra"
          type="close"
          @click="onComplete"
        />
      </a>
      <template slot="title">
        {{ taskForm.homeworkName }}
      </template>
      <a-spin
        :spinning="spinning"
        tip="Loading..."
      >
        <div :style="{height:'700px',borderRadius: '5px', background: 'linear-gradient(#339999,white)'}">
          <!-- 题目列表页 -->
          <first-form
            ref="first"
            @changeFirst="changeFirst"
          ></first-form>
          <!-- 题目详情页 -->
          <after-form
            ref="after"
            @answerChange="answerCode"
          ></after-form>
          <!-- 答题卡 -->
          <answer-form
            ref="answer"
            @returnChange="returnChange"
            @locationChange="locationChange"
            @onClose="onClose"
          ></answer-form>
          <!-- 加载数据失败 -->
          <error-form
            ref="error"
            @reloadChange="onClose"
          ></error-form>
        </div>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import { getGroupList, getTaskList } from '@/api/datum/readWrite'
import { addRecordList } from '@/api/task/taskDetails'
import FirstForm from './HomeWorkRW/TaskFirstRW'
import AfterForm from './HomeWorkRW/TaskAfterRW'
import AnswerForm from './HomeWorkRW/AnswerCard'
import ErrorForm from './ExamError'
export default {
  components: {
    FirstForm,
    AfterForm,
    AnswerForm,
    ErrorForm
  },
  data () {
    return {
      spinning: false,
      closeVisible: false,
      taskForm: {},
      queryParam: {},
      mdlOption: [],
      Index: 0
    }
  },
  created () {
    this.taskForm = this.$route.query
    // console.log('taskForm:' + JSON.stringify(this.$route.query))
    this.handleExamData()
  },
  methods: {
    handleExamData () {
      this.closeVisible = false
      this.spinning = true
      this.mdlOption = []
      this.queryParam = {}
      if (this.taskForm.examType === '1') {
        this.queryParam.unitId = this.taskForm.examPaperId
      } else {
        this.queryParam.simulationId = this.taskForm.examPaperId
      }
      this.queryParam.bookId = this.taskForm.bookId
      this.queryParam.examType = this.taskForm.examType
      getGroupList(Object.assign(this.queryParam)).then(res => {
        const groupData = res.result
        groupData.forEach((item, i) => {
          if (item.mdlType === '1' || item.mdlType === '4') {
            this.mdlOption.push({
              key: this.Index++,
              moduleId: item.moduleId,
              title: item.mdlName,
              type: item.mdlType,
              explain: item.mdlExplain,
              average: item.average,
              totalScore: item.totalScore,
              option: []
            })
          } else {
            this.mdlOption.push({
              key: this.Index++,
              moduleId: item.moduleId,
              title: item.mdlName,
              type: item.mdlType,
              explain: item.mdlExplain,
              average: item.average,
              totalScore: item.totalScore,
              questionId: '',
              recordId: '',
              option: []
            })
          }
        })
        this.$refs.first.handleOpen(this.taskForm, this.mdlOption)
      }).catch(() => {
        this.$refs.error.handleOpen()
      }).finally(() => {
        this.spinning = false
      })
    },
    getTaskList () {
      this.spinning = true
      getTaskList(Object.assign(this.queryParam)).then(res => {
        const data = res.result
        this.mdlOption.forEach((item, i) => {
          data.forEach((items, i) => {
            if (item.moduleId === items.moduleId) {
              if (items.mdlType === '1' || items.mdlType === '4' || items.mdlType === '5') {
                if (typeof (items.recordId) !== 'undefined') {
                  const newItem = JSON.parse(items.score)
                  newItem.recordId = items.recordId
                  newItem.questionId = items.id
                  item.option.push(newItem)
                } else {
                  const newItem = JSON.parse(items.content)
                  newItem.questionId = items.id
                  newItem.recordId = items.recordId
                  item.option.push(newItem)
                }
              } else {
                if (typeof (items.recordId) !== 'undefined') {
                  item.option.push(JSON.parse(items.score))
                  item.recordId = items.recordId
                } else {
                  item.option.push(JSON.parse(items.content))
                }
                item.questionId = items.id
              }
            }
          })
        })
        // console.log('data:' + JSON.stringify(this.mdlOption))
        this.$refs.after.handleOpen(this.mdlOption)
      }).catch(() => {
        this.$refs.error.handleOpen()
      }).finally(() => {
        this.spinning = false
      })
    },
    // 打开模块列表画面
    changeFirst () {
      this.closeVisible = true
      this.getTaskList()
    },
    // 打开答题卡
    answerCode (value) {
      this.mdlOption = value
      this.$refs.answer.handleOpen(this.taskForm, this.mdlOption)
    },
    // 返回练习
    returnChange () {
      this.$refs.after.handleOpen(this.mdlOption)
    },
    // 点击定位题目
    locationChange (value) {
      this.$refs.after.handleLocation(value)
    },
    onClose () {
      this.$router.push({ path: 'task' })
    },
    // 完成
    onComplete () {
      // console.log('保存精度')
      this.$confirm({
        title: '作业未完成，是否确认退出?',
        content: '退出后将保存做题进度',
        okText: '退出',
        cancelText: '取消',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        }
      })
    },
    clickHandler () {
      if (this.handleRecord().length > 0) {
        addRecordList(Object.assign(this.handleRecord())).then(res => {
          this.$message.success('进度保存成功!')
        }).catch(() => {
          this.$message.error('进度保存失败')
        }).finally(() => {
          this.onClose()
        })
      } else {
        this.onClose()
      }
    },
    // 进度保存
    handleRecord () {
      const recordList = []
      this.mdlOption.forEach((item, i) => {
        if (item.type === '1') {
          const data = item.option
          data.forEach((items, i) => {
            if (items.result !== '') {
              recordList.push({
                id: items.recordId,
                questionId: items.questionId,
                studentId: this.studentId,
                score: JSON.stringify(items)
              })
            }
          })
        }
        if (item.type === '2') {
          const data = item.option[0]
          var reg = new RegExp('<input type="text" class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>', 'g')
          data.title = data.title.replace(reg, '_')
          let num2 = 0
          data.choiceList.forEach((items, i) => {
            if (items.result !== '') {
              num2 = num2 + 1
            }
          })
          if (num2 > 0) {
            recordList.push({
              id: item.recordId,
              questionId: item.questionId,
              studentId: this.studentId,
              score: JSON.stringify(data)
            })
          }
        }
        if (item.type === '3') {
          const data = item.option[0]
          var reg2 = new RegExp('<input type="text" disabled class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>', 'g')
          data.title = data.title.replace(reg2, '_')
          let num2 = 0
          data.questionList.forEach((items, i) => {
            if (items.result !== '') {
              num2 = num2 + 1
            }
          })
          if (num2 > 0) {
            recordList.push({
              id: item.recordId,
              questionId: item.questionId,
              studentId: this.studentId,
              score: JSON.stringify(data)
            })
          }
        }
        if (item.type === '4') {
          const data = item.option
          data.forEach((items, i) => {
            let num2 = 0
            items.questionList.forEach((item2, i) => {
              if (item2.result !== '') {
                num2 = num2 + 1
              }
            })
            if (num2 > 0) {
              recordList.push({
                id: items.recordId,
                questionId: items.questionId,
                studentId: this.studentId,
                score: JSON.stringify(items)
              })
            }
          })
        }
        if (item.type === '5') {
          const data = item.option
          data.forEach((item0, i) => {
            let num2 = 0
            item0.choiceList.forEach((items, i) => {
              if (items.result !== '') {
                num2 = num2 + 1
              }
            })
            if (num2 > 0) {
              recordList.push({
                id: item0.recordId,
                questionId: item0.questionId,
                studentId: this.studentId,
                score: JSON.stringify(item0)
              })
            }
          })
        }
      })
      return recordList
    }
  }
}
</script>
